import { render, staticRenderFns } from "./vipStore.vue?vue&type=template&id=6af75d7f&"
import script from "./vipStore.vue?vue&type=script&lang=js&"
export * from "./vipStore.vue?vue&type=script&lang=js&"
import style0 from "./vipStore.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports